export const durationString = (ms: number) => {
  const formattedString = new Date(ms).toISOString().slice(11, 19);
  return formattedString.startsWith("00")
    ? formattedString.slice(3)
    : formattedString;
};
